import { IAppState } from "../core/redux/IAppState";
import { ACTION_TYPE } from "../core/redux/actionType";
import { updateBreaker } from "../core/redux/api/circuitBreaker/module";
import { getProductMappingErrorSW } from "../core/redux/api/endpoints";
import { addError, addLoading, removeLoadingAndError } from "../core/redux/api/module";
import { ApiReducer, RsaaTypes, makeApiAction, makeApiReducer } from "../core/redux/api/reduxStandardApiAction";
import { assoc } from "../language/module";
import { getResource } from "../language/resources/getResource";
import { ResortMappingObject, SiriuswareMappingProduct } from "./productMappings";

const KEY_ACTION = ACTION_TYPE.UPDATE_PRODUCT_MAPPING_REQUEST_SW;
const ACTIONS    = [
  ACTION_TYPE.UPDATE_PRODUCT_MAPPING_REQUEST_SW,
  ACTION_TYPE.UPDATE_PRODUCT_MAPPING_RESPONSE_SW,
  ACTION_TYPE.UPDATE_PRODUCT_MAPPING_ERROR_SW,
];


/**
 * Makes an action that can be dispatched to get a Resorts Entitlements for the Resort Entitlement Mapping Tool.
 */
export const UpdateResortMappingsSWAction = (payload: SiriuswareMappingProduct) => makeApiAction(
  {
    method:   'GET',
    headers:  (state: IAppState) => ({
      'content-type':  'application/json',
      'Authorization': `Bearer ${state.auth.bearerToken}`,
    }),
    endpoint: state => getProductMappingErrorSW(state.selectedResort.resortAbbreviation, payload.department, payload.item, payload.category),
    types:    ACTIONS as RsaaTypes,
    bailout:  (state: IAppState) => false
  },
);

const reducer: ApiReducer<SiriuswareMappingProduct> = (
    state,
    action,
    error,
    isLoading
  ): IAppState => {
  
    if (isLoading) {
      return addLoading(state, KEY_ACTION, KEY_ACTION);
    }
  
    const withBreaker = updateBreaker(state, KEY_ACTION, !!error);
  
    if (error) {
      return addError(
        withBreaker,
        KEY_ACTION,
        KEY_ACTION,
        getResource(state.locale, 'UPDATE_MAPPING_ERRORS_ACTION_ERROR'),
      );
    }

    const noLoadingOrError = removeLoadingAndError(withBreaker, KEY_ACTION, KEY_ACTION);

    const updatedRow = action.payload as SiriuswareMappingProduct;
    const isRtp = state.resortMappingHistories.posProvider === 'RTP';

    if (!updatedRow) return noLoadingOrError;

    const isMappingError = updatedRow.errorDescription != null && updatedRow.errorDescription !== "";

    const updatedEntitlementArray = state.resortMappingHistories.productMappings.map((element) =>
        (element.department === updatedRow.department 
          && element.item === updatedRow.item 
          && element.category === updatedRow.category) 
        ? {...element, isError: isMappingError, errorDescription: updatedRow.errorDescription} 
        : element);

    const newObj: ResortMappingObject = {
        posProvider: isRtp ? 'RTP' : 'Siriusware',
        productMappings: updatedEntitlementArray,
        hasError: state.resortMappingHistories.hasError
    };
  
    return assoc('resortMappingHistories', newObj, noLoadingOrError);
  };
  
  
  /**
   * Function that maps actions into new app state. Specifically, updates app state with information from actions related
   * to a guest's redemptions at resorts while using a specific pass. Returns a new app state, of course.
   */
  export const updateResortMappingSWReducer = makeApiReducer<SiriuswareMappingProduct>(ACTIONS, KEY_ACTION, reducer);
  